/* eslint-disable import/prefer-default-export */

import {
  LESSON_DETAILS__GET_LESSON,
  LESSON_DETAILS__GET_LESSON_SUCCESS,
  LESSON_DETAILS__GET_LESSON_FAIL,
  LESSON_DETAILS__GET_LESSON_TEXT_NOTES,
  LESSON_DETAILS__GET_LESSON_TEXT_NOTES_SUCCESS,
  LESSON_DETAILS__GET_LESSON_TEXT_NOTES_FAIL,
  LESSON_DETAILS__GET_LESSON_VIDEO_NOTES,
  LESSON_DETAILS__GET_LESSON_VIDEO_NOTES_SUCCESS,
  LESSON_DETAILS__GET_LESSON_VIDEO_NOTES_FAIL,
  LESSON_DETAILS__RESET_LESSON,
  LESSON_DETAILS__UPDATE_STATE,
  LESSON_DETAILS__COMPLETE_LESSON,
  LESSON_DETAILS__RESET_VIDEO_NOTES,
  LESSON_DETAILS__RESET_TEXT_NOTES,
  LESSON_DETAILS__GET_LESSON_CHANGELOG,
  LESSON_DETAILS__GET_LESSON_CHANGELOG_SUCCESS,
  LESSON_DETAILS__GET_LESSON_CHANGELOG_FAIL,
  LESSON_DETAILS__COMPLETE_LESSON_SUCCESS,
  LESSON_DETAILS__COMPLETE_LESSON_FAIL,
  LESSON_DETAILS__COMPLETE_LESSON_RESET_ERROR,
} from '../constants';
import { buildQuery } from '../helpers';

export function getLessonBySlug(slug, params = {}) {
  return {
    types: [
      LESSON_DETAILS__GET_LESSON,
      LESSON_DETAILS__GET_LESSON_SUCCESS,
      LESSON_DETAILS__GET_LESSON_FAIL,
    ],
    promise: fetch =>
      fetch(`/api/lessons/by-slug/${slug}?${buildQuery(params)}`, {
        method: 'GET',
      }),
  };
}

export function getLessonTextNotes(courseId, lessonId) {
  return {
    types: [
      LESSON_DETAILS__GET_LESSON_TEXT_NOTES,
      LESSON_DETAILS__GET_LESSON_TEXT_NOTES_SUCCESS,
      LESSON_DETAILS__GET_LESSON_TEXT_NOTES_FAIL,
    ],
    promise: fetch =>
      fetch(`/api/courses/${courseId}/text-notes/${lessonId}`, {
        method: 'GET',
      }),
  };
}

export function getLessonVideoNotes(courseId, lessonId) {
  return {
    types: [
      LESSON_DETAILS__GET_LESSON_VIDEO_NOTES,
      LESSON_DETAILS__GET_LESSON_VIDEO_NOTES_SUCCESS,
      LESSON_DETAILS__GET_LESSON_VIDEO_NOTES_FAIL,
    ],
    promise: fetch =>
      fetch(`/api/courses/${courseId}/video-notes/${lessonId}`, {
        method: 'GET',
      }),
  };
}

export function getLessonChangelog(lessonId) {
  return {
    types: [
      LESSON_DETAILS__GET_LESSON_CHANGELOG,
      LESSON_DETAILS__GET_LESSON_CHANGELOG_SUCCESS,
      LESSON_DETAILS__GET_LESSON_CHANGELOG_FAIL,
    ],
    promise: fetch =>
      fetch(
        `/api/lessons/${lessonId}/changes?page=1&perPage=50&sort=-createDate`,
        {
          method: 'GET',
        },
      ),
  };
}
export function updateState(field, value) {
  return {
    type: LESSON_DETAILS__UPDATE_STATE,
    payload: [field, value],
  };
}

export function reset() {
  return {
    type: LESSON_DETAILS__RESET_LESSON,
  };
}

export function resetVideoNotes() {
  return {
    type: LESSON_DETAILS__RESET_VIDEO_NOTES,
  };
}

export function resetTextNotes() {
  return {
    type: LESSON_DETAILS__RESET_TEXT_NOTES,
  };
}

export function completeLesson({ lessonId, courseId }) {
  return {
    types: [
      LESSON_DETAILS__COMPLETE_LESSON,
      LESSON_DETAILS__COMPLETE_LESSON_SUCCESS,
      LESSON_DETAILS__COMPLETE_LESSON_FAIL,
    ],
    promise: fetch =>
      fetch(`/api/lessons/${lessonId}/complete?${buildQuery({ courseId })}`, {
        method: 'PUT',
      }),
  };
}

export function resetCompletedLesson() {
  return {
    type: LESSON_DETAILS__COMPLETE_LESSON_RESET_ERROR,
  };
}
